import { makeStyles } from "@material-ui/core";

export default makeStyles(()=>({
    loaderHolder:{
        height : "fit-content",
        width:"fit-content",
        padding:"2rem",
        background:"transparent",
        margin:"auto auto"
    }
}))